var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { computed } from '@ember/object';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { fragment } from 'ember-data-model-fragments/attributes';
let MeasurementUnit = (_dec = attr('string', {
  defaultValue: CatalogObjectType.MEASUREMENT_UNIT,
  protoEnum: CatalogObjectTypeProto
}), _dec2 = fragment('connect/measurement-unit/data'), _dec3 = computed('measurementUnitData.measurementUnit.{areaUnit,lengthUnit,volumeUnit,weightUnit,timeUnit,genericUnit}'), _class = (_class2 = class MeasurementUnit extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "measurementUnitData", _descriptor2, this);
  }
  get measurementUnitTypeKey() {
    if (this.measurementUnitData?.measurementUnit?.areaUnit) {
      return 'areaUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.lengthUnit) {
      return 'lengthUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.volumeUnit) {
      return 'volumeUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.weightUnit) {
      return 'weightUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.timeUnit) {
      return 'timeUnit';
    }
    if (this.measurementUnitData?.measurementUnit?.genericUnit) {
      return 'genericUnit';
    }
    return 'customUnit';
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/measurement-unit'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "measurementUnitData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "measurementUnitTypeKey", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "measurementUnitTypeKey"), _class.prototype), _class);
export { MeasurementUnit as default };